import support from './support.js';

export default {
  checkCompany(company) {
    return support.post("checkCompany", {
      company: company
    });
  }

}
